import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import GuidelinesContentEn from './guidelines.content.en';
import GuidelinesContentJa from './guidelines.content.ja';

import PageContainer from '../../components/PageContainer';

const GuidelinesContent: FC = () => {
  const {
    i18n: { language },
    t,
  } = useTranslation();

  return (
    <PageContainer title={t('staticPages:guidelines.title')}>
      {language === 'en' ? <GuidelinesContentEn /> : <GuidelinesContentJa />}
    </PageContainer>
  );
};

export default GuidelinesContent;
